<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>連絡先グループ変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>グループ名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="group.groupName" class="form-control" autocomplete="off" placeholder="グループ名" required>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="isHierarchyGroupEnabled">
            <div class="row">
              <div class="col-3">
                <label>階層</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="group.hierarchyNo" disabled>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group" v-show="isHierarchyGroupEnabled">
            <div class="row">
              <div class="col-3">
                <label>親グループ</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="group.parentId" disabled>
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
              </div>
            </div>  
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      name: 'group',
      message: '',
      groupOptions: [],
      group: {
        groupName: ''
      }
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isHierarchyGroupEnabled: function () {
      return this.$store.getters.contact.isHierarchyGroupEnabled
    }
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var groupId = this.$route.params.id;
        var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                      ? "/api/hierarchygroup/management/" + groupId
                      : "/api/group/management/public/" + groupId
        axios.get(url, {
            headers: this.headers(accessToken)
        }).then(response => {
          this.group = response.data.data.group;
          this.getHierarchylist(this.group.hierarchyNo - 1)
        }).catch(err => {
          this.message = err.message
        })
      }}).catch((err) => {
        this.message = err.message
      })
  },
  methods: {
    modify() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                      ? "/api/hierarchygroup/management" 
                      : "/api/group/management/public"
          axios.put(url, {
              group: this.group
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
    },
    destroy() {
      if(confirm('削除してもよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var groupId = this.$route.params.id;
          var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                      ? "/api/hierarchygroup/management/" + groupId 
                      : "/api/group/management/public/" + groupId
          axios.delete(url, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
    getHierarchylist(hierarchyNo) {
      if(!this.$store.getters.contact.isHierarchyGroupEnabled) return
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var extraContactId = this.$route.params.extraContactId
          axios.post("/api/hierarchygroup/management/hierarchylist/", {
            hospitalId: hospitalId,
            extraContactId: extraContactId,
            hierarchyNo: hierarchyNo
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            this.groupOptions = response.data.data.groups
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>